<template>
  <div>
    <el-dialog title="广告记录" :visible.sync="dialogVisible" width="1100px">
      <div class="filter-grid">
        <!-- <el-input v-model.trim="queryForm.trans_id" size="small" placeholder="搜索 Trans ID" /> -->
        <!-- <el-input v-model.trim="queryForm.ad_tag" size="small" placeholder="搜索广告标签" /> -->
        <el-input v-model.trim="queryForm.name" size="small" placeholder="搜索广告名称" />
        <!-- <el-input v-model.trim="queryForm.mediation_rit" size="small" placeholder="搜索 Mediation RIT" /> -->
        <!-- <el-input v-model.trim="queryForm.prime_rit" size="small" placeholder="搜索 Prime RIT" /> -->
        <el-select v-model="queryForm.accounting" clearable size="small" placeholder="分佣状态">
          <el-option label="已分佣" value="1" />
          <el-option label="分佣失败" value="0" />
        </el-select>
        <!-- <el-select v-model="queryForm.type" clearable size="small" placeholder="广告类型">
          <el-option label="奖励" value="奖励" />
          <el-option label="插屏" value="插屏" />
          <el-option label="开屏" value="开屏" />
          <el-option label="信息流" value="信息流" />
        </el-select> -->
        <el-date-picker
          v-model="timeRange"
          type="datetimerange"
          size="small"
          value-format="timestamp"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="handleTimeChange"
        />
        <div class="filter-actions">
          <el-button type="primary" size="small" @click="search">查询</el-button>
          <el-button size="small" @click="resetSearch">重置</el-button>
        </div>
      </div>

      <AccessadTable :list="list" :loading="loading" :showUserSummary="false" />

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationForm.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="paginationForm.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AccessadTable from "@/components/accessad/components/AccessadTable.vue";

function createDefaultQueryForm() {
  return {
    user_id: "",
    trans_id: "",
    ad_tag: "",
    name: "",
    accounting: "",
    mediation_rit: "",
    prime_rit: "",
    type: "",
    start_time: "",
    end_time: "",
  };
}

export default {
  components: {
    AccessadTable,
  },
  data() {
    return {
      list: [],
      dialogVisible: false,
      loading: false,
      timeRange: [],
      total: 0,
      queryForm: createDefaultQueryForm(),
      paginationForm: {
        page: 1,
        page_size: 20,
      },
      pageCursorMap: {
        1: 0,
      },
      fetchedPageMap: {},
      hasMore: true,
    };
  },
  methods: {
    resetCursorState() {
      this.pageCursorMap = { 1: 0 };
      this.fetchedPageMap = {};
      this.hasMore = true;
      this.total = 0;
      this.list = [];
    },
    getEffectiveParams() {
      return {
        ...this.queryForm,
        page_size: this.paginationForm.page_size,
        last_id: this.pageCursorMap[this.paginationForm.page] || 0,
      };
    },
    async ensureCursorForPage(page) {
      if (page <= 1 || this.pageCursorMap[page] !== undefined) {
        return true;
      }

      let currentPage = 1;
      while (currentPage < page) {
        if (this.pageCursorMap[currentPage + 1] !== undefined) {
          currentPage += 1;
          continue;
        }

        if (!this.hasMore) {
          return false;
        }

        const data = await this.$api.getAccessad.getAccessadList({
          ...this.queryForm,
          page_size: this.paginationForm.page_size,
          last_id: this.pageCursorMap[currentPage] || 0,
        });

        const nextList = data.data && data.data.list ? data.data.list : [];
        this.hasMore = Boolean(data.data && data.data.has_more);
        const nextLastId = data.data && data.data.last_id ? data.data.last_id : 0;

        this.fetchedPageMap[currentPage] = nextList;

        if (this.hasMore && nextList.length) {
          this.pageCursorMap[currentPage + 1] = nextLastId;
          this.total = Math.max(this.total, (currentPage + 1) * this.paginationForm.page_size);
        } else {
          this.pageCursorMap[currentPage + 1] = nextLastId || 0;
          this.total = (currentPage - 1) * this.paginationForm.page_size + nextList.length;
        }

        currentPage += 1;
      }

      return true;
    },
    async getList() {
      this.loading = true;
      try {
        const page = this.paginationForm.page;
        if (page > 1) {
          const ok = await this.ensureCursorForPage(page);
          if (!ok) {
            this.list = [];
            return;
          }
        }

        if (this.fetchedPageMap[page]) {
          this.list = this.fetchedPageMap[page];
          return;
        }

        const data = await this.$api.getAccessad.getAccessadList(this.getEffectiveParams());
        const nextList = data.data && data.data.list ? data.data.list : [];
        this.hasMore = Boolean(data.data && data.data.has_more);
        const nextLastId = data.data && data.data.last_id ? data.data.last_id : 0;
        this.fetchedPageMap[page] = nextList;
        this.list = nextList;

        if (this.hasMore && nextList.length) {
          this.pageCursorMap[page + 1] = nextLastId;
          this.total = Math.max(this.total, (page + 1) * this.paginationForm.page_size);
        } else {
          this.pageCursorMap[page + 1] = nextLastId || 0;
          this.total = (page - 1) * this.paginationForm.page_size + nextList.length;
        }
      } finally {
        this.loading = false;
      }
    },
    openDialog(userId) {
      this.queryForm = {
        ...createDefaultQueryForm(),
        user_id: userId,
      };
      this.paginationForm.page = 1;
      this.paginationForm.page_size = 20;
      this.timeRange = [];
      this.resetCursorState();
      this.getList();
      this.dialogVisible = true;
    },
    handleCurrentChange(page) {
      this.paginationForm.page = page;
      this.getList();
    },
    handleSizeChange(size) {
      this.paginationForm.page_size = size;
      this.paginationForm.page = 1;
      this.resetCursorState();
      this.getList();
    },
    handleTimeChange(value) {
      if (!value) {
        this.queryForm.start_time = "";
        this.queryForm.end_time = "";
        return;
      }
      this.queryForm.start_time = Math.floor(Number(value[0]) / 1000);
      this.queryForm.end_time = Math.floor(Number(value[1]) / 1000);
    },
    search() {
      this.paginationForm.page = 1;
      this.resetCursorState();
      this.getList();
    },
    resetSearch() {
      const userId = this.queryForm.user_id;
      this.queryForm = {
        ...createDefaultQueryForm(),
        user_id: userId,
      };
      this.paginationForm.page = 1;
      this.timeRange = [];
      this.resetCursorState();
      this.getList();
    },
  },
};
</script>

<style scoped>
.filter-grid {
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  align-items: center;
}

.filter-actions {
  display: flex;
  gap: 8px;
}

.pagination {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 16px;
}
</style>
